import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledIframe = styled('iframe')(() => ({
  width: '100%',
  height: '100vh',
  border: 'none',
}));

const StyledCircularProgress = styled(CircularProgress)(() => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  zIndex: 1,
}));

function FormIframe({ url, title }: any) {
  const [ready, setReady] = React.useState(false);
  const iframeRef = React.useRef(null);

  if (!url) {
    return null;
  }

  React.useEffect(() => {
    if (iframeRef.current) {
      iframeRef.current.addEventListener('load', () => {
        setReady(true);
      });
    }

    return () => {
      if (iframeRef.current) {
        iframeRef.current.removeEventListener('load', () => {
          setReady(true);
        });
      }
    };
  }, [iframeRef.current]);

  return (
    <Box sx={{ position: 'relative', minHeight: '80vh', width: '100%' }}>
      {!ready && <StyledCircularProgress size={40} />}
      <StyledIframe title={title} src={url} ref={iframeRef} />
    </Box>
  );
}

export default FormIframe;
